<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useRecertificationDialogStore } from '@/stores/recertificationDialogStore'
import CommonButton from '@/components/common/button/CommonButton.vue'
import { BModal } from 'bootstrap-vue-next'
import MiiaFwConfig from '@/configs/config'

const commonModalStore = useRecertificationDialogStore()
const { isOpen, password } = storeToRefs(commonModalStore)
const body = 'パスワードを入力してください。'
const okTitle = 'OK'
const cancelTitle = 'キャンセル'
</script>

<template>
  <BModal
    style="z-index: 10002"
    v-model="isOpen"
    size="sm"
    :title="MiiaFwConfig.config.sysName"
    :ok-only="false"
    :no-header-close="true"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @ok="commonModalStore.ok"
    @cancel="commonModalStore.cancel"
  >
    <div v-html="body"></div>
    <BFormInput type="password" v-model="password" />

    <template #cancel="{ cancel }">
      <CommonButton size="sm" variant="secondary" @click="cancel()">{{ cancelTitle }}</CommonButton>
    </template>
    <template #ok="{ ok }">
      <CommonButton size="sm" variant="primary" @click="ok()">{{ okTitle }}</CommonButton>
    </template>
  </BModal>
</template>

<style lang="scss" scoped></style>
